import React, { lazy } from 'react';
export function FlyingBird() {
  return <div className="absolute top-1/3 right-0 w-32 h-32 z-10 pointer-events-none" aria-hidden="true" data-id="element-22">
      <div className="animate-[fly-arc_8s_ease-in-out_infinite] w-full h-full" data-id="element-23">
        <iframe src="https://lottie.host/embed/f0484e5c-1fc6-4362-a16a-5dd7fe2c356c/HQN2dvS8e9.lottie" title="Flying bird animation" className="w-full h-full border-0 bg-transparent" style={{
        background: 'transparent'
      }} loading="lazy" data-id="element-24" />
      </div>
    </div>;
}